import React from 'react'
import ShipContent from './ShipContent'
import ShipSearch from './ShipSearch'
import Loading from '../../components/Loading/Loading'
import apiBarcode from '../../services/api/apiBarcode'
import PubSub from 'pubsub-js'
import {pushNewItemHistory} from "../../services/api/apiItemHistory"
import uniqueArray from "../helpers/uniqueArray"
import checkSameNumber from "../helpers/checkSameNumber"
import ableToPrint from "../../components/AbleToPrint/ableToPrint"
import {generateLabelShip} from "../../services/api/apiNextBarcode"
import {listTypeForce} from "./listTypeForce"
import { Spin } from 'antd'
import checkSameNumberCombine from '../helpers/checkSameNumberCombine'
import parseBarcodeNumber from '../helpers/parseBarcodeNumber'

class ShipPage extends React.Component {
    state = {
        barcodeNumber: '',
        item: null,
        isLoading: false,
        isShowSearch: true,
        barcodeNumbers: [],
        mustGenLabel: false,
        isLoadingPrint: false
    }

    componentDidMount() {
        PubSub.subscribe('FOCUS_INPUT_SEARCH', this._showSearch)
    }

    _showSearch = () => {
        this.setState({isShowSearch: true, barcodeNumber: '', barcodeNumbers: []})
    }

    _handleChangeInput = (e) => {
        const {name, value} = e.target
        this.setState({[name]: value})
    }

    _fetchItem = async (params = '', init = false) => {
        const {barcodeNumber} = this.state
        if (!barcodeNumber) return

        try {
            let newItem = null
            let newPartnerTrackingNumber = ''

            if (!barcodeNumber.startsWith('#')) throw new Error('Invalid ID.')

            const trimmedNumber = barcodeNumber.replace('#', '')
            const codes = trimmedNumber.split('_')
            const newParams = (params !== '') ? `${params}&item=${codes[1]}` : `item=${codes[1]}`
            const resRead = await apiBarcode.getBarcodeByNumber(codes[0], newParams)
            const {success, data, message} = resRead.data
            const { labelDetails, batch_ship } = { ...data }
            const {status: batchStatus, id:batchId} = {...batch_ship}
            const { shipping_carrier } = { ...labelDetails }

            if (!success) throw Error(message)

            if (!data) throw new Error('No items found.')

            if (this._hasUpdateAddressRequest(data) && this._hasNoLabel(data)) {
                throw new Error(`Đơn ${barcodeNumber} đang request update address và chưa có label!`)
            }

            if (shipping_carrier === 'SB_FAST') {
                if (!!batchStatus && batchStatus !== 'confirmed' && shipping_carrier === 'SB_FAST') {
                    throw new Error(`Lô ship ${batchId} cần confirmed trước khi dán label!`)
                }
                if (!batchStatus && shipping_carrier === 'SB_FAST') {
                    throw new Error('Đơn hàng SB_FAST phải được cho vào lô ship trước khi dán label!')
                }
            } else {
                if (data.order_type !== 'FBA') {
                    if (data.status === 'error' && data.labels.length === 0 && shipping_carrier !== 'SB_FAST') {
                        throw new Error('Lỗi không gen được Label, báo lại với team support')
                    }
                } else {
                    const { split_fba_item_label_status, split_fba_item_label } = data
                    if ((!split_fba_item_label_status || split_fba_item_label_status !== 'success' || !split_fba_item_label) && shipping_carrier !== 'SB_FAST') {
                        throw new Error('Lỗi tách label, báo lại với team support')
                    }
                }

                if (data.hasOwnProperty('_id') && shipping_carrier !== 'SB_FAST') {
                    if (data.must_generate_new_label !== undefined && data.must_generate_new_label && data.production_status !== 'packaged') {
                        newItem = await this._handleCheckGenAuto(data)

                        if (newItem === null) {
                            return false
                        }

                        const { labelDetails } = newItem

                        newPartnerTrackingNumber = labelDetails.partnerTrackingNumber
                    }
                }
            }

            this.setState({item: data, isLoading: false}, () => {
                if (!init) return

                const {labelDetails} = Object.assign({}, data)
                const {partnerTrackingNumber} = Object.assign({}, labelDetails)

                pushNewItemHistory(barcodeNumber, {
                    event_key: 'scan_to_label_standard',
                    event_description: 'Scan QR to label.',
                    event_meta: {
                        partnerTrackingNumber: newPartnerTrackingNumber ? newPartnerTrackingNumber : partnerTrackingNumber,
                    }
                })

                if (newItem !== null) this.setState({
                    item: newItem
                })

                return true
            })

        } catch (e) {
            alert(e.message)
            this.setState({
                isShowSearch: true,
                item: null,
                isLoading: false
            })
        }
    }

    // Quy trình mới gen label từ FFM không đẩy note xuống FAC, nên đơn update address trên FFM
    // không bị chặn ở FAC. Request update address là request cho cả đơn (order-level), nên chỉ
    // check tag trên order. Cover cả lúc đang chờ update ('waiting-update-address') lẫn lúc đã
    // update xong nhưng chưa gen lại label ('updated-address'). Check tại bước dán label để chặn.
    _hasUpdateAddressRequest = (order) => {
        if (!order || !Array.isArray(order.tags)) return false

        const addressRequestTags = ['waiting-update-address', 'updated-address']
        return order.tags.some(tag => addressRequestTags.includes(tag))
    }

    // Các màn in/hiển thị label đều dựa vào labelDetails (partnerTrackingNumber / url / trackingNumber),
    // không dùng mảng labels. Nên coi là chưa có label khi labelDetails chưa có dữ liệu in được.
    _hasNoLabel = (order) => {
        if (!order) return true

        const {labelDetails} = order
        if (!(labelDetails instanceof Object)) return true

        const {partnerTrackingNumber, url, trackingNumber} = labelDetails
        return !partnerTrackingNumber && !url && !trackingNumber
    }

    _handleCheckGenAuto = async (order) => {
        this.setState({
            mustGenLabel: true
        })
        try {
            const payload = {
                status: order.gen_at !== undefined ? 'regenerated' : 'generated'
            }

            const {data, success, message} = await generateLabelShip(order._id, payload)

            if (!success) throw new Error(message)

            this.setState({
                mustGenLabel: false
            })

            return data
        } catch (e) {
            this.setState({
                mustGenLabel: false
            })
            alert(e.message)
            return null
        }
    }

    _checkIncludeCombine = (orders, barcode) => {
        const parsedBarcode = parseBarcodeNumber(barcode)

        const parsedOrders = orders.map(item => item.barcodeNumber)

        return parsedOrders.includes(parsedBarcode.number)
    }

    _changeBarcodeNumbersCombine = (barcodeNumbers, barcode) => {
        const parsedBarcode = parseBarcodeNumber(barcode)
        const newBarcodeNumbers = barcodeNumbers.map(item => {
            const parsedItem = parseBarcodeNumber(item)
            if(parsedItem.number === parsedBarcode.number){
                return barcode
            }else{
                return item
            }
        })

        return newBarcodeNumbers
    }

    _getNewBarcodeNumbers = (barcode) => {
        const {barcodeNumbers, item} = this.state

        if (!barcodeNumbers.length) {
            return [].concat(barcodeNumbers, [barcode])
        }

        if(item && item.siblingsBarcodes){
            const isSameCombine = checkSameNumberCombine(barcodeNumbers, barcode)
    
            if (isSameCombine) {
                const newBarcodeNumbers = this._changeBarcodeNumbersCombine(barcodeNumbers, barcode)
                return newBarcodeNumbers
            }

            const isIncludeCombine = this._checkIncludeCombine(item.siblingsBarcodes, barcode)
            if (!isIncludeCombine) {
                return [barcode]
            }
        }else{
            const isSame = checkSameNumber(barcodeNumbers[0], barcode)
    
            if (!isSame) {
                return [barcode]
            }
        }

        return uniqueArray([].concat(barcodeNumbers, [barcode]))
    }

    _handleSubmit = async (barcode) => {

        this.setState({
            isLoading: true,
            isShowSearch: false,
            barcodeNumber: barcode,
            // barcodeNumbers: vBarcodeNumbers
        }, async () => {
            const able = await ableToPrint(barcode, 'print_label', () => {
                this.setState({
                    barcodeNumber: '',
                    // item: null,
                    isLoading: false,
                    isShowSearch: true,
                    // barcodeNumbers: [],
                })
            })

            if (!able) {
                return false;
            }
            
            const vBarcodeNumbers = this._getNewBarcodeNumbers(barcode)
            this.setState({
                barcodeNumbers: vBarcodeNumbers
            }, async() => {
                await this._fetchItem('page=shipPage', true)
            })

        })
    }

    _renderLoading = () => {
        const {isLoading} = this.state

        if (isLoading) return <Loading/>
    }

    _renderContent = () => {
        const {isLoading, item, barcodeNumber, barcodeNumbers} = this.state
        const data = this._getStatusData()

        if (!data) return ''

        const {current, total} = data

        if (!isLoading && item) {
            return <ShipContent
                item={item}
                total={total}
                current={current}
                barcodeNumber={barcodeNumber}
                reloadItem={this._fetchItem}
                ableToPrint={this._ableToPrintLabel}
                onLoadingPrint={this._handleChangeLoadingPrint}
                barcodeNumbers={barcodeNumbers}
            />
        }
    }

    _getStatusData = () => {
        const {barcodeNumbers, item} = this.state

        if (!item || typeof item !== 'object') return false

        if (!barcodeNumbers || !barcodeNumbers.length) return false

        const {products, order_type, tags = [], siblingsBarcodes = []} = item
        const hasCombineShipTag = tags.some(item => /^combine-ship(-\w+)?$/.test(item))
        const hasComboFacTag = tags.includes('combo_fac')

        const total = hasCombineShipTag ? siblingsBarcodes.length + 1 : (products && products.length) ? products.length : 0

        if (!total) return false

        const listType = products.map(product => {
            return product.type
        })

        const uniqueChars = [...new Set(listType)]
        let arrFilter = listType

        if (uniqueChars.length === 1) {
            arrFilter = products.filter(product => {
                const {type} = product

                return !listTypeForce.includes(type)
            })
        }

        const itemsFilter = arrFilter.length > 0 ? arrFilter.filter(itemFilter => itemFilter.type !== 'FILTER') : []
        const force = order_type === 'FBA' || !itemsFilter.length

        return {
            current: barcodeNumbers.length,
            total,
            force,
            hasCombineShipTag,
            hasComboFacTag
        }
    }

    _getStatus = () => {
        const data = this._getStatusData()

        if (!data) return ''

        const {current, total, hasCombineShipTag, hasComboFacTag} = data

        // return `${current} / ${total}`
        return (
            <>
            {current} / {total}
            {
                hasCombineShipTag && !hasComboFacTag &&
                <div style={{fontSize: '14px', color: 'red'}}>(Đơn gộp cần quét mỗi đơn 1 item.)</div>
            }
            </>
        )
    }

    _ableToPrintLabel = () => {
        const { item } = this.state
        const { products, tags = [] } = item
        const cancelItem = products.filter(product => product.status === "cancelled")
        const hasCombineShipTag = tags.some(item => /^combine-ship(-\w+)?$/.test(item))
        const data = this._getStatusData()

        if (!data) return false

        const { current, total, force } = data

        if (hasCombineShipTag) return (current + cancelItem.length) >= total

        if (force) return true

        return (current + cancelItem.length) >= total || current >= 5
    }

    _handleChangeLoadingPrint = (isLoadingPrint) => {
        this.setState({isLoadingPrint})
    }

    render() {
        const {barcodeNumber, isShowSearch, item, mustGenLabel} = this.state

        return (
            <Spin tip='Printing...' spinning={this.state.isLoadingPrint}>
                <div className='ShipPage'>
                    {
                        <ShipSearch
                            item={item}
                            value={barcodeNumber}
                            status={this._getStatus()}
                            onSubmit={this._handleSubmit}
                        />
                    }

                    {
                        (!isShowSearch && !mustGenLabel) && this._renderLoading()
                    }

                    {
                        (!isShowSearch && !mustGenLabel) && this._renderContent()
                    }

                    {
                        mustGenLabel && (
                            <div className="text-center">Label này đã qua 13 ngày chưa được generate, hệ thống đang generate
                                label trước khi in <i className="fa fa-spinner fa-spin"/></div>)
                    }
                </div>
            </Spin>
        )
    }
}

export default ShipPage
